import { render, staticRenderFns } from "./NominationsCreatePortal.vue?vue&type=template&id=079306ee&"
import script from "./NominationsCreatePortal.vue?vue&type=script&lang=js&"
export * from "./NominationsCreatePortal.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports